export default function PalSDK (pPlayer) {
  this._player = pPlayer;
	this._nonceLoader;
	this._palInstance;
	this._managerPromise;
	this._nonceManager;
	this._storageConsent = true;
	this._playbackStarted = false;
	this._ssid = generateUUID();

	this.init = function () {
		if (!window["goog"]) return;
		if (window["goog"]["pal"]) this._palInstance = window["goog"]["pal"];
		if (window["goog"]["ctv"] && window["goog"]["ctv"]["pal"]) this._palInstance = window["goog"]["ctv"]["pal"];
		if (!this._palInstance) return;

		var consentSettings = new this._palInstance.ConsentSettings();
		consentSettings.allowStorage = false;

		this._nonceLoader = new this._palInstance.NonceLoader(consentSettings);
	}

	this.start = function () {
		if (!this._nonceManager && this._nonceLoader) {
      var request = new this._palInstance.NonceRequest();
			request.adWillAutoPlay = true;
			request.adWillPlayMuted = false;
			request.continuousPlayback = false;
			//request.descriptionUrl = 'https://example.com';
			request.iconsSupported = true;
			request.playerType = 'Sample Player Type';
			request.playerVersion = '1.0';
			request.ppid = this._player.config.deviceID || "";
			request.sessionId = this._ssid;
			// Player support for VPAID 2.0, OMID 1.0, and SIMID 1.1
			request.supportedApiFrameworks = '2,7,9';
			//request.url = 'https://developers.google.com/ad-manager/pal/html5';
			request.videoHeight = this._player.config.screenHeight || 480;
			request.videoWidth = this._player.config.screenWidth || 640;

			this._nonceLoader.loadNonceManager(request).then((manager) => {
				this._nonceManager = manager;
				this._player.config.palNonce = this._nonceManager.getNonce();
				this._nonceManager.sendPlaybackStart();
			}).catch((error) => {});
		}
	}

	this.stop = function () {
		if(this._nonceManager) {
			this._nonceManager.sendPlaybackEnd();
			this._player.config.palNonce = "";
			this._nonceManager = null;
		}
	}

	function generateUUID() { // Public Domain/MIT
		var d = new Date().getTime();//Timestamp
		var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16;//random number between 0 and 16
			if(d > 0){//Use timestamp until depleted
				r = (d + r)%16 | 0;
				d = Math.floor(d/16);
			} else {//Use microseconds since page-load if supported
				r = (d2 + r)%16 | 0;
				d2 = Math.floor(d2/16);
			}
			return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
		});
	}
}
